import React, { Component } from 'react';
import { ThemeContext } from '../../../context/theme.context';
import GlobalGrid from '../../../components/GlobalGrid';
import { drilingColumns } from './Columns';
interface IProps {
  workbench_data: any;
}
interface IState {
  workbench_id: number;
  signal: boolean;
}
class Drilling extends Component<IProps, IState> {
  public toolbarOptions: any = [
    'Add',
    'Edit',
    'Delete',
    'Update',
    'Cancel',
    {
      text: 'Refresh',
      tooltipText: 'Refresh',
      prefixIcon: 'e-refresh',
      id: 'refresh',
    },
    'ColumnChooser',
    'ExcelExport',
    'Search',
  ];
  public validationNumberRule: Object = { required: true, number: true };
  static contextType = ThemeContext;
  context!: React.ContextType<typeof ThemeContext>;
  private gridWorkbenchDrillingObj: any;
  private created_date = new Date();
  private unit: string = 'dril';
  constructor(props: IProps) {
    super(props);
    this.state = {
      workbench_id: -1,
      signal: false,
    };
  }
  componentDidMount() {
    let workbench_id = parseInt(this.props.workbench_data.id);
    this.created_date = new Date(this.props.workbench_data.date);
    this.setState({ workbench_id: (workbench_id), signal: true });
  }
  render() {
    return (
      <div>
        <GlobalGrid
          id='shift-workbench-driling'
          columns={drilingColumns}
          query={`${this.unit}$${this.state.workbench_id}`}
          toolbarOptions={this.toolbarOptions}
          get_query={'shift-workbench/workbench-sub-stuff'}
          edit_query={'shift-workbench/workbench-sub-stuff/edit'}
          add_query={'shift-workbench/workbench-sub-stuff/create'}
          delete_query={'shift-workbench/workbench-sub-stuff/delete'}
          noNeedPagination={true}
          signalOfLoad={this.state.signal}
          additionalCrudParams={{
            workbench_id: this.state.workbench_id,
            date: this.created_date,
            unit: this.unit,
          }}
          height={'calc(-200px + 60vh)'}
        />
      </div>
    );
  }
}
export default Drilling;
